import { PointerInfo, PointerButton } from "@egr/wcf/modules/core/view/InputState";
import { SceneElement, BasicElement } from '@egr/wcf/modules/core/mdl';
import { Vector2 } from "@babylonjs/core/Maths/math.vector";
import { AbstractInteractorTool } from './tools';
import { MainArticleElement } from "@egr/wcf/modules/cf";
import { eq } from "@egr/wcf/modules/utils/math";
import { CoordinatesType } from "@egr/wcf/modules/core/view/View";
import { ReplaceObjects as cmdReplaceObjects } from "../cmd/ReplaceObjects";
export class ReplaceObjects extends AbstractInteractorTool {
    constructor(pRoomManager) {
        super(pRoomManager);
        this.mPickedPos = null;
        this.mSelection = [];
        this.mTouchMode = false;
    }
    stop() {
        super.stop();
        this.mRoomManager.endInteraction();
        this.mApp.model.endSelectionChange();
    }
    handlePointerDown(pEvent, pState) {
        this.mTouchMode = pState.pointerType !== "mouse";
    }
    handlePointerUp(pEvent, pState) {
        this.checkSelection();
        let tPointer = pState.pointers.get(pEvent.pointerId);
        if (tPointer == null)
            return;
        if (pState.isPrimaryPointer(pEvent)) {
            let tElement = this.getPickedElement(tPointer.position, !tPointer.isMousePointer, undefined);
            if (tElement == null ||
                !((tElement instanceof MainArticleElement) || (tElement instanceof BasicElement))) {
                this.stop();
                return;
            }
            let tCmd = new cmdReplaceObjects(this.mRoomManager, this.mSelection, tElement);
            this.mApp.commands.executeCommand(tCmd);
            this.finish();
        }
        else {
            //stop on right mouse click
            let tisMousePointer = PointerInfo.IsMousePointer(pEvent);
            let tinitialButton = tPointer.initialButton === PointerButton.Right ? true : false;
            if (tisMousePointer && tinitialButton) {
                let tDist = Vector2.Distance(tPointer.initialPosition, tPointer.position);
                if (eq(tDist, 0))
                    this.stop();
            }
        }
    }
    //// protected /////////////////////////////////////////////////////////////////////////////
    startPos(pPos) {
        //
    }
    updatePointerPosition(pPos) {
        //
    }
    finish() {
        this.mRoomManager.app.model.setSelection(this.mSelection);
        this.stop();
    }
    checkSelection() {
        let tSelection = this.mRoomManager.app.model.selection;
        if (tSelection.length == 0) {
            this.stop();
            return;
        }
        this.mSelection = tSelection;
    }
    getPickedElement(pPos, pUseFrustum, rPickPos) {
        let tView = this.mView;
        if (tView == null)
            tView = this.mRoomManager.hoverView;
        if (tView == null)
            return (null);
        let tPickInfo = null;
        if (pUseFrustum)
            tPickInfo = tView.pickSceneWithFrustum(pPos, 30, 30, CoordinatesType.Client);
        else
            tPickInfo = tView.pickScene(pPos, CoordinatesType.Client);
        if (tPickInfo != null && tPickInfo.hit && tPickInfo.pickedMesh != null) {
            this.mPickedPos = tPickInfo.pickedPoint;
            if (this.mPickedPos != null)
                this.mPickedPos.y = 0;
            return (SceneElement.FromNode(tPickInfo.pickedMesh, true));
        }
        return (null);
    }
}
